import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'wo-inline-label',
  styleUrls: [ './inline-label.component.scss' ],
  templateUrl: './inline-label.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InlineLabelComponent {
  @Input() public label!: string;
  @Input() public value!: unknown;
}
